import { createSlice } from "@reduxjs/toolkit";

const ReportSlice = createSlice({
  name: "report",
  initialState: {},
  reducers: {
    getBarGraphData: () => {},
  },
});

export const ReportSliceAction = ReportSlice.actions;
export default ReportSlice.reducer;
